import React, { Component } from 'react'
import { inject } from 'mobx-react'
import propTypes from 'prop-types'

class LoginAsModal extends Component {
  static propTypes = {
    token: propTypes.object.isRequired
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    shouldCloseOnOverlayClick: true
  }

  render () {
    return (
      <div>
        <h1>Quick login link</h1>
        <p>
          Please use login link below to log in as{' '}
          <strong>{this.props.token.user.fullName}</strong>
        </p>
        <p>
          <a href={this.props.token.link} className='word-break-all'>
            {this.props.token.link}
          </a>
        </p>
        <p className='text-gray'>
          <div>
            <strong>Please note:</strong> clicking the above link will log you
            out from your current session and log you in as listed user.
          </div>
          <div>
            If you wish to remain loged in as admin user in this window right
            click on link above and select{' '}
            <strong>open in inconito window</strong> (shorcut: g)
          </div>
        </p>
      </div>
    )
  }
}

export default inject('modalStore')(LoginAsModal)
